import React from 'react';

const subtextStyle = {
  display: 'flex',
  fontSize: '0.6875rem',
  justifyContent: 'center',
  marginTop: '0.375rem'
};

const boldStyle = {
  fontWeight: 700
};

function ReferralSubtext({ isVisible }) {
  if (!isVisible) {
    return null;
  }

  return (
    <div css={subtextStyle}>
      <span>
        <span css={boldStyle}>Please note: </span>
        If your application is funded, your referrer may receive compensation.
      </span>
    </div>
  );
}

export default ReferralSubtext;
